import { useEnableSignUpSignInABTest } from 'pages/authentication/use-enable-sign-up-sign-in-a-b-test';
import { routes } from 'utils/routing';

/** use this to get to the proper "login" page over a redirect on signup to sign in because:
 * - it will crash android with talkback active
 * - redirect has bad UX (you can see the previous screen)
 * - analytics are showing the extra, incorrect hop.*/
export const useGetLoginRoute = () => {
  const enableSignUpSignInABTest = useEnableSignUpSignInABTest();
  return enableSignUpSignInABTest ? routes.signIn : routes.signUp;
};
